<template>
    <div class="wrapper">
        <!--头条新闻栏-->
        <div class="headerWrap">
            <div class="headLine">
                <!--头条警示-->
                <div :class="[isActive ? 'content-center' : '', 'title']">
                    <div class="tdwrap">
                        <span class="today"><img src="../assets/image/toutiao1.png" alt="" /></span>
                        <div style="
                            font-size: 20px;
                            color: white;
                            top: 2px;
                            position: absolute;
                            height: 32px;
                            line-height: 31px;
                            right: 12px;
                            font-weight: 600;
                            width: 110px;
                            background: #294b7f;
                          ">
                            消费快评
                        </div>
                    </div>
                    <router-link class="todayNews" v-if="topNewsA && topNewsA.type === 2" :to="{
                      name: 'complainInfo',
                      query: {
                        id: topNewsA.id,
                        cate: topNewsA.cate,
                        cateTitle: '消费快评',
                      },
                    }" v-text="topNewsA.title">
                    </router-link>
                    <router-link v-else class="todayNews" :to="{
                      name: 'article',
                      query: { id: topNewsA.id, cateTitle: '消费快评' },
                    }" v-text="topNewsA.title">
                    </router-link>
                </div>
                <!--小标题-->
                <div class="smallTitle" style="margin-left: 30px">
                    <span v-if="topNewsB" style="margin: 0 5px; font-weight: 600">·</span>
                    <router-link v-if="topNewsB && topNewsB.type === 2" class="small-text" :to="{
                      name: 'complainInfo',
                      query: {
                        id: topNewsB.id,
                        cate: topNewsB.cate,
                        cateTitle: '消费快评',
                      },
                    }" v-text="topNewsB.title">
                    </router-link>
                    <router-link v-if="topNewsB" :to="{
              name: 'article',
              query: { id: topNewsB.id, cateTitle: '消费快评' },
            }" class="small-text" v-text="topNewsB.title">
                    </router-link>
                    <span v-if="topNewsC" style="margin: 0 5px; font-weight: 600">·</span>
                    <router-link v-if="topNewsC && topNewsC.type === 2" class="small-text" :to="{
              name: 'complainInfo',
              query: {
                id: topNewsC.id,
                cate: topNewsC.cate,
                cateTitle: '消费快评',
              },
            }" v-text="topNewsC.title">
                    </router-link>
                    <router-link v-if="topNewsC" :to="{
              name: 'article',
              query: { id: topNewsC.id, cateTitle: '消费快评' },
            }" class="small-text" v-text="topNewsC.title">
                    </router-link>
                    <span v-if="topNewsD" style="margin: 0 5px; font-weight: 600">·</span>
                    <router-link v-if="topNewsD && topNewsD.type === 2" class="small-text" :to="{
              name: 'complainInfo',
              query: {
                id: topNewsD.id,
                cate: topNewsD.cate,
                cateTitle: '消费快评',
              },
            }" v-text="topNewsD.title">
                    </router-link>
                    <router-link v-if="topNewsD" :to="{
              name: 'article',
              query: { id: topNewsD.id, cateTitle: '消费快评' },
            }" class="small-text" v-text="topNewsD.title">
                    </router-link>
                </div>
            </div>
            <!--//头条右侧广告-->
            <template v-if="smAds[0]">
                <a class="advertising" style="display: block" :href="smAds[0].dirlink" v-if="smAds[0].type === 1">
                    <object data="" type="">
                        <embed class="guanggao" :src="smAds[0].logo" type="" />
                    </object>
                </a>
                <a class="advertising" style="display: block" :href="smAds[0].dirlink" v-else>
                    <img class="guanggao" :src="smAds[0].logo" alt="" />
                </a>
            </template>
        </div>
        <!-- 排行榜 -->
        <div class="rank-wrap" v-if="isActive_rank">
            <Ranking v-cloak :type="1" title="投诉榜" :list="leader_board" v-if="leader_board.length"></Ranking>
            <CommentRank v-cloak :type="3" title="评论榜" :list="comment" v-if="comment.length"></CommentRank>
            <Ranking v-cloak :type="2" title="和解榜" :list="peace" v-if="peace.length"></Ranking>
        </div>
        <!--轮播新闻栏-->
        <div class="swiper-news">
            <NewSwiper :banner="banner"></NewSwiper>
            <div class="news-list">
                <div class="import-news">
                    <!--谈阔论-->
                    <router-link tag="div" class="list-title-wrap" text="谈阔论" :to="{ name: 'articleList', query: {type: 1, cateTitle: '谈阔论' }}">
                        <div class="title">谈阔论</div>
                        <div class="more-btn">more</div>
                    </router-link>
                    <ul v-if="today_news.length">
                        <li v-for="(item, index) in today_news" class="today-news" style="cursor: pointer" :key="index">
                            <router-link v-if="item.type === 1" :to="{ name: 'article', query: { id: item.id, cateTitle: '谈阔论' }, }" v-text="item.title">
                            </router-link>
                            <router-link v-if="item.type === 2" :to="{ name: 'complainInfo', query: { id: item.id, cate: item.cate, cateTitle: '谈阔论', }, }" v-text="item.title">
                            </router-link>
                        </li>
                    </ul>
                </div>
                <template v-if="smAds[1]">
                    <a style="display: block; margin-left: -15px" :href="smAds[1].dirlink" v-if="smAds[1].type === 1">
                        <object data="" type="">
                            <embed class="guanggao" :src="smAds[1].logo" type="" />
                        </object>
                    </a>
                    <a :href="smAds[1].dirlink" style="display: block; margin-left: -15px" v-else>
                        <img class="news-guanggao" :src="smAds[1].logo" alt="" />
                    </a>
                </template>
                <!--言万语-->
                <div class="import-news">
                    <!--言万语-->
                    <router-link tag="div" class="list-title-wrap" text="言万语" :to="{ name: 'articleList', query: {type: 2, cateTitle: '言万语' }}">
                        <div class="title">言万语</div>
                        <div class="more-btn">more</div>
                    </router-link>
                    <ul v-if="complaint.length">
                        <li v-for="(item,idx) in complaint" :key="idx" class="today-news" style="cursor: pointer">
                            <router-link v-if="item.type === 1" :to="{name: 'article',query: { id: item.id, cateTitle: '言万语' },}" v-text="item.title">
                            </router-link>
                            <router-link v-if="item.type === 2" :to="{name: 'complainInfo',query: {id: item.id,cate: item.cate,cateTitle: '言万语',},}" v-text="item.title">
                            </router-link>
                        </li>
                    </ul>
                </div>
                <!--<div>-->
            </div>
            <!--投诉和解中心-->
            <div class="complain-wrap-new">
                <a v-if="smAds[4]" :href="smAds[4].dirlink" target="_blank">
                    <object data="" type="">
                        <embed :src="smAds[4].logo" type="" style="width: 100%; height: 100%" />
                    </object>
                </a>
            </div>
            <!-- nanfeng 2020年10月09日21:17:46 -->
            <div class="complain-wrap" v-if="false">
                <div>
                    <img class="complain-img" src="../assets/image/hejie2.png" alt="" />
                </div>
                <div class="complain-iconA">
                    <div class="icon-wrap">
                        <el-dialog title="和解须知" :visible.sync="centerDialogVisible" width="30%" center>
                            <span>
                                根据《中华人民共和国消费者权益保护法》有关规定，<br />
                                投诉前请您认真阅读以下文字：
                                若您投诉的问题属于下列之一，本网将不予受理：<br />
                                1、没有明确的诉求或者没有真实准确的被投诉方；<br />
                                2、经营者之间因购销活动产生的纠纷；<br />
                                3、因经营、投资、技术转让、再生产等以营利为目的的活动引发争议的；<br />
                                4、公民个人之间私下交易或通过非法渠道购买商品或者接受服务的。<br />
                                5、消费者对投诉商品或者服务的瑕疵在购买或者接受之前已经知道的；<br />
                                6、消费者不能提供必要证据的。<br />
                                7、举报政府部门或工作人员失职、渎职或腐败行为的；<br />
                                8、争议双方曾达成调解协议并已履行，且无新情况、理由和新证据的；<br />
                                9、法院、仲裁机构或有关行政部门已受理的；<br />
                                10、消费者未按产品使用说明安装、使用、保管、自行拆动而导致产品损坏或人身、财产损害的；<br />
                                11、因不可抗力造成损害的。<br />
                                12、其他不符合有关法律、法规规定的。
                            </span>
                            <span slot="footer" class="dialog-footer"> </span>
                        </el-dialog>
                        <img class="icon" src="../assets/image/tousu-img.png" alt="和解须知" @click="centerDialogVisible = true" />
                        <span style="margin-left: 10px">
                            <el-button style="margin-left: 5px; font-size: 15px" type="text" @click="centerDialogVisible = true">和解须知</el-button>
                        </span>
                    </div>
                    <div class="icon-wrap" @click="toComplainOnline">
                        <img class="icon complain" src="../assets/image/tousu2.png" alt="我要投诉" />
                        <span style="margin-left: 10px; margin-top: 8px; color: #409eff">我要和解</span>
                    </div>
                </div>
                <hr class="hr" />
                <div class="complain-iconB">
                    <!--二维码-->
                    <div class="icon-wrap-qr">
                        <img class="QR-icon" :src="QRimg" />
                        <span class="weixinCode" style="">{{ weChat }}</span>
                    </div>
                    <div class="phone-number">
                        <span> <i class="iconfont icon-dianhua1"></i>{{ mobile }} </span>
                        <span> <i class="iconfont icon-youjian"></i>{{ email }} </span>
                        <span> <i class="iconfont icon-QQ1"></i>{{ qq }} </span>
                    </div>
                </div>
            </div>
        </div>
        <!--投诉排行榜上方广告-->
        <div class="guanggao-wrap">
            <template v-if="images[1]">
                <a class="hengfu" :href="images[1].dirlink" target="_blank" v-if="images[1].type === 1">
                    <object data="" type="">
                        <embed :src="images[1].logo" type="" style="width: 790px; height: 100px" />
                    </object>
                </a>
                <a class="hengfu" :href="images[1].dirlink" target="_blank">
                    <img style="width: 790px; height: 100px" :src="images[1].logo" alt="" />
                </a>
            </template>
            <template v-if="smAds[3]">
                <a class="hengfu" :href="smAds[3].dirlink" target="_blank" v-if="smAds[3].type === 1">
                    <object data="" type="">
                        <embed :src="smAds[3].logo" type="" style="width: 790px; height: 100px" />
                    </object>
                </a>
                <a style="display: block; margin-left: 30px" :href="smAds[3].dirlink" target="_blank" v-else>
                    <img style="width: 380px; height: 100px" :src="smAds[3].logo" alt="" />
                </a>
            </template>
        </div>
    </div>
</template>
<script>
import NewSwiper from "./News-swiper";
import Ranking from "@/components/Ranking.vue";
import CommentRank from "@/components/CommentRank.vue";

export default {
    name: "FrontTitle",
    props: {},
    data() {
        return {
            images: [],
            today_news: [],
            banner: "",
            top_article: [],
            complaint: "",
            articleArr: [],
            todayContent: [],
            centerDialogVisible: false,
            smAds: [],
            topNews: [],
            topNewsA: "",
            topNewsB: "",
            topNewsC: "",
            topNewsD: "",
            mobile: "",
            qq: "",
            email: "",
            QRimg: "",
            isActive: "",
            weChat: "",
            isActive_rank: false,
            leader_board: [],
            peace: [],
            comment: [],
        };
    },
    created() {
        this.getCrunchies();
        this.getArticle();
        this.guangGao();
    },

    methods: {
        // 获取投诉排行
        getCrunchies() {
            this.$get("/index/index/center_article")
                .then((res) => {
                    if (res.code === 0) {
                        this.leader_board = res.data.leader_board;
                        this.peace = res.data.peace;
                        this.comment = res.data.comment;
                        this.isActive_rank = true;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        // 获取谈阔论相关数据
        getArticle() {
            this.$get("/index/index/article")
                .then((res) => {
                    if (res.code === 0) {
                        this.banner = res.data.banner;
                        this.today_news = res.data.today_news;
                        this.complaint = res.data.complaint;
                        let top_article = res.data.top_article;
                        this.topNewsA = res.data.top_article[0];
                        this.topNewsB = res.data.top_article[1];
                        this.topNewsC = res.data.top_article[2];
                        this.topNewsD = res.data.top_article[3];
                        if (this.topNewsB === undefined) {
                            this.isActive = true;
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        guangGao() {
            this.$get("/index/index/ad_position")
                .then((res) => {
                    if (res.code === 0) {
                        this.images = res.data.images;
                        this.smAds = res.data.sm_ads;
                        this.mobile = res.data.customer_mobile;
                        this.qq = res.data.customer_qq;
                        this.email = res.data.contacts_email;
                        this.QRimg = res.data.qr_code;
                        this.weChat = res.data.weixin_name;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        toComplainOnline() {
            this.$router.push({ name: "ComplainOnline" });
        },
    },
    components: {
        NewSwiper,
        Ranking,
        CommentRank,
    },
};
</script>
<style scoped lang="less">
.list-title-wrap {
    overflow: hidden;
    border-bottom: 2px solid #4a90e2;
    margin-bottom: 20px;
    position: relative;

    .title {
        float: left;
        cursor: pointer;
        padding: 4px 10px;
        color: #ff5300;
        font-size: 20px;
        transition: background-color 0.2s;
        border-right: none;
        font-weight: bold;
    }

    .more-btn {
        position: absolute;
        top: 0;
        right: 0;
        font-size: 16px;
        font-weight: 600;
        color: #5fb071;
        line-height: 36px;
        padding: 0 10px;
        cursor: pointer;
    }
}

.small-text {
    display: inline-block;
    max-width: 410px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 10px;
}

.wrapper {
    max-width: 1200px;
    margin: 40px auto 32px auto;
}

.hengfu {
    width: 790px;
    height: 100px;
}

.headerWrap {
    display: inline-flex;
}

.headLine {
    width: 856px;
    height: 100px;
    border: 1px solid #bbb;

    .tdwrap {
        width: 129px;
        height: 32px;
        background: #294b7f;
        text-align: center;
        margin-top: 23px;
        position: relative;
    }

    .today {
        font-size: 22px;
        font-family: MicrosoftYaHei-Bold;
        font-weight: bold;
        line-height: 29px;
        color: rgba(255, 255, 255, 1);

        .today>img {
            width: 129px;
            height: 32px;
        }
    }

    .today-news:first-child {
        font-size: 16px;
        font-family: MicrosoftYaHei-Bold;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 21px;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 370px;
    }

    .today-newsB {
        margin: 15px 0 !important;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 370px;
    }

    .title {
        display: flex;
        padding-left: 20px;

        .todayNews {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 687px;
            height: 42px;
            font-size: 32px;
            font-family: MicrosoftYaHei-Bold;
            font-weight: bold;
            color: rgba(51, 51, 51, 1);
            line-height: 42px;
            margin-top: 16px;
            margin-left: 15px;
        }
    }

    .content-center {
        margin-top: 12px;
    }

    .smallTitle {
        display: flex;
        align-items: center;
        margin-top: 10px;
        cursor: pointer;
    }
}

.advertising {
    margin-left: 24px;

    .guanggao {
        width: 320px;
        height: 100px;
    }
}

.swiper-news {
    display: inline-flex;
    margin-top: 32px;
    max-width: 1200px;

    .news-list {
        width: 380px;
        height: 400px;
        margin-left: 30px;

        .news-guanggao {
            width: 380px;
            height: 48px;
            margin: 6px 0;
            object-fit: unset;
        }
    }
}

.import-news>ul>li {
    list-style: disc;
    height: 19px;
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold;
    color: rgba(51, 51, 51, 1);
    line-height: 19px;
    margin: 8px 0;
}

.import-news>ul>li:nth-child(1) {
    height: 21px;
    font-size: 19px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    line-height: 21px;
}

.complain-iconA,
.complain-iconB {
    display: flex;
    justify-content: space-around;
    margin-top: 10px;
}

.QR-icon {
    width: 85px;
    height: 85px;
}

.complain-wrap {
    width: 320px;
    height: 309px;
    border: 1px solid #bbb;
    margin-left: 10px;

    .complain-img {
        width: 320px;
        height: 42px;
    }

    .icon-wrap {
        display: flex;
        flex-direction: column;
        cursor: pointer;

        .icon {
            width: 88px;
            height: 88px;
        }
    }

    .icon-wrap-qr {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-left: 20px;
    }

    .hr {
        width: 280px;
    }
}

.complain-wrap-new {
    width: 380px;
    height: 400px;
    border: 1px solid #bbb;
    margin-left: 20px;

    img {
        display: block;
        width: 100%;
        height: 100%;
    }
}

.phone-number {
    margin-left: 10px;
    height: 78px;
    width: 115px;

    span {
        font-size: 12px;
        color: #333;
        display: inline-block;
        white-space: nowrap;
        margin: 5px 0;
    }
}

.guanggao-wrap {
    display: flex;
    width: 1200px;
    height: 100px;
    margin: 0 auto;
    margin-top: 50px;
}

.guanggao-right {
    width: 380px;
    margin-left: 50px;
    margin-top: 30px;

    img {
        width: 380px;
        height: 100px;
    }
}

.complain {
    animation: scale 0.08s alternate infinite;
}

.weixinCode {
    font-size: 12px;
    display: inline-block;
    text-align: center;
    white-space: pre;
}

@keyframes scale {
    from {
        transform: scale(1);
    }

    to {
        transform: scale(0.88);
    }
}
</style>